<script setup lang="ts">
/**
 * Gradient overlay with circular action buttons for image thumbnails.
 * Always visible on mobile, hover-only on desktop (parent must have `group` class).
 */
defineProps<{
  forceVisible?: boolean
}>()
</script>

<template>
  <div
    class="absolute inset-x-0 bottom-0 flex justify-end gap-1 bg-gradient-to-t from-black/50 to-transparent p-1.5 transition-opacity sm:opacity-0 sm:group-hover:opacity-100"
    :class="{ '!opacity-100': forceVisible }"
  >
    <slot />
  </div>
</template>
